import { Divider } from '@mui/material';
import useStylesForm from 'common/components/styles/useStylesForm.styles';
import { useTranslation } from 'react-i18next';

const ProductFormNav = (props) => {
    const { step, setStep, enableVariants } = props;

    const { t } = useTranslation();

    const { classes, cx } = useStylesForm();

    return (
        <div className={classes.headerNavigation}>
            {enableVariants && <Divider className={classes.navLine} />}
            <div className={cx(classes.navButton, step === 1 && classes.navActive)} onClick={() => setStep(1)}>
                {t('product.productFormNav.configuration')}
            </div>
            {enableVariants && (
                <div
                    className={cx(classes.navButton, step === 2 && classes.navActive)}
                    onClick={() => step > 2 && setStep(2)}
                >
                    {t('product.productFormNav.versions')}
                </div>
            )}
        </div>
    );
};

export default ProductFormNav;
